import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function changeStatusFailure(draft: Draft<IManufacturerData>) {
  draft.changeStatus.config.isLoading = false;
}

export default changeStatusFailure;
